var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliceArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0757 0.567803C14.8706 3.43998 16.3682 7.95341 24 7.95341L1.30763e-06 7.95341M15.0757 15.4322C14.8706 12.56 16.3682 8.04656 24 8.04656",
    stroke: "#5E58F6",
    strokeWidth: 1.04513
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliceArrowRight);
export default __webpack_public_path__ + "static/media/slice-arrow-right.123fa2a57b5342d525751f562f12eae9.svg";
export { ForwardRef as ReactComponent };